<script setup lang="ts">
import { ref } from "vue";
import { Permission } from "../../../../types/auth";
import SalesGoodsReturnsForm from "./SalesGoodsReturnsForm.vue";
import { RecordStatus } from "../../../../types/models";
import { FilterField, TableField } from "../../../../components/table/table";
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";

const endPoint = "/clients/revenue/sales/sales-goods-returns/";
const title = "Sales Goods Returns";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);
const showReceivePayment = ref(false)
const permissions = ref<Permission[]>();

const fields: TableField[] = [
  { name: "date_time", caption: "Date", sortable: true, fieldType: "date" },
  {
    name: "document_no",
    caption: "Ref. No",
    sortable: true,
    fieldType: "text",
  },
  {
    name: "warehouse",
    caption: "Warehouse",
    sortable: true,
    fieldType: "text",
  },
  { name: "outlet", caption: "Outlet", sortable: true, fieldType: "text" },
  { name: "customer", caption: "customer", sortable: true, fieldType: "text" },
  { name: "net_total", caption: "Amount", sortable: true, fieldType: "number" },
  {
    name: "sales_channel",
    caption: "Channel",
    sortable: true,
    fieldType: "text",
  },
  {
    name: "credit_term",
    caption: "Payment Terms",
    sortable: true,
    fieldType: "text",
  },
  {
    name: "sales_person",
    caption: "Sales Rep",
    sortable: true,
    fieldType: "text",
  },
  {
    name: "customer_reference",
    caption: "customer Reference",
    sortable: true,
    fieldType: "text",
  },
  {
    name: "record_status",
    caption: "Status",
    sortable: false,
    fieldType: "text",
  },
];

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};

const record_status = ref<RecordStatus[]>([]);

const handleLists = (list: any) => {
  record_status.value = list["record_status"];
};

const handleTableActions = (action: any, data: any)  => {
  selectedData.value = data
  if (action == 'receive-payment') {
    showReceivePayment.value = true
  }
}

const handlePermissions = (perm: Permission[]) => {
  permissions.value = perm;
};

const listViewRef = ref<InstanceType<typeof ListTemplate> | null>(null);
const viewDocument = (data : any, title: string, path: string) => {
  if (listViewRef.value) {
    listViewRef.value.viewDocument(data, title, path);
  }
}

</script>

<template>
  <ListTemplate
   ref="listViewRef"
    :endPoint="endPoint"
    :title="title"
    :fields="fields"
    :actions="[]"
    :filterFields="filterFields"
    @permissions="handlePermissions"
    :tabList="[]"
    :refreshData="refreshData"
    @custom="handleTableActions"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @lists="handleLists"
    :allow-disable="false"
    :show-quick-view="true"
    :show-share-actions="true"
    :allow-edit="false"
    @data="handleData"
  >
    <template #form-view>
      <SalesGoodsReturnsForm
        v-if="showForm"
        :permissions="permissions"
        :record-status="record_status"
        @view-document="viewDocument"
        :data="selectedData"
        :end-point="endPoint"
        :title="title"
        :mode="formMode"
        @save="refreshData = !refreshData"
        @close="showForm = !showForm"
      />
    </template>
  </ListTemplate>
  
</template>
